interface Props {
  disabled: boolean;
}

const SvgMinus: React.FC<Props> = ({ disabled }) => {
  return (
    <svg
      style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15683_9514)">
        <path
          d="M2 5.20003C1.89399 5.19853 1.78874 5.21812 1.69037 5.25765C1.59199 5.29718 1.50245 5.35587 1.42696 5.4303C1.35146 5.50474 1.29151 5.59344 1.2506 5.69124C1.20968 5.78905 1.18861 5.89401 1.18861 6.00003C1.18861 6.10605 1.20968 6.21101 1.2506 6.30882C1.29151 6.40663 1.35146 6.49532 1.42696 6.56976C1.50245 6.64419 1.59199 6.70288 1.69037 6.74241C1.78874 6.78195 1.89399 6.80153 2 6.80003C6.6712 6.80003 4.82974 6.80003 10 6.80003C10.106 6.80153 10.2113 6.78195 10.3096 6.74241C10.408 6.70288 10.4975 6.64419 10.573 6.56976C10.6485 6.49532 10.7085 6.40663 10.7494 6.30882C10.7903 6.21101 10.8114 6.10605 10.8114 6.00003C10.8114 5.89401 10.7903 5.78905 10.7494 5.69124C10.7085 5.59344 10.6485 5.50474 10.573 5.4303C10.4975 5.35587 10.408 5.29718 10.3096 5.25765C10.2113 5.21812 10.106 5.19853 10 5.20003C4.85474 5.20003 6.651 5.20003 2 5.20003Z"
          className={`${disabled ? "fill-gray3" : "fill-current"}`}
        />
      </g>
      <defs>
        <clipPath id="clip0_15683_9514">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgMinus;
